import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, Loading } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02iCustomerManagementPage } from '../b02i-customer-management/b02i-customer-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { MyApp } from '../../app/app.component';

/**
 * Generated class for the B02iaCustomerAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b02ia-customer-add',
  templateUrl: 'b02ia-customer-add.html',
})
export class B02iaCustomerAddPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  public errorMessage: any = "";

  corpData = {  CORP_NAME:'',
                ADDR1:'', ADDR2:'', ADDR3:'',
                CONTACT_NO: '', EMAIL:'', PIC:'',
                CORP_ACTIVE:'YES',            
              }

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController) {

    this.todo = this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
//      town: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
//      country: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])],
      pic: ['', Validators.required],
      active: ['', Validators.required],
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02iaCustomerAddPage');
  }

  save(){
    this.showLoader();

    this.serviceapi.insertdata("CORPORATE",this.corpData).then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1"){
          this.loading.dismiss();
          this.navCtrl.setRoot(B02iCustomerManagementPage);
        }
        else{
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });

    
  }

  goToUser(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B02iCustomerManagementPage);
  }

  showLoader(){
//    clearTimeout();                               //clear previouse timeout

    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        dismissOnPageChange: true,
        duration: 5000
    });

    this.loading.present();

/*     setTimeout(() => {
      if(this.loading.instance){                  //check if loading still showing
        this.errorMessage = "Loading timeout";
        this.loading.dismiss();
      }

    }, 5000); */
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      dismissOnPageChange: true
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02ia-customer-add/b02ia-customer-add.ts